import $ from 'jquery';
import run from '../../utilities/run';
import EditChecker from '../../components/EditChecker/EditChecker';
import { setElementsFromScope, setOptionsForSelect } from "../../utilities/selectorHelpers";
import { rgxTest } from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";

run("#notification-preferences-config-form", ()=>{
  const el = $("#notification-preferences-config-form");
  notificationPreferenceConfig(el);
});

function notificationPreferenceConfig(el){
	const submitModalFlow = new SubmitModalFlow();
  	submitModalFlow.init();
  	const els = {};
  	const elementsMap = {
  		workOrderNotification : "#workOrderNotification",
  		orderErrorNotification : "#orderErrorNotification",
  		saveNotificationConfig : ".save-notification-preference",
		saveNotificationModal: "#save-confirmation-modal",
		inboundReceivingNotification : "#inboundReceivingNotifications",
		inboundStatusCompleteNotification:"#inboundStatusCompleteNotification",
		inboundAgingNotification:"#inboundAgingNotification",
		bulkOrderUploadFailsNotification: "#bulkOrderUploadFailsNotification",
		addressValidationFailureNotification: '#addressValidationFailureNotification',
		transferOrderShippedNotification: "#transferOrderShippedNotification",
		transferOrderReceivedNotification: '#transferOrderReceivedNotification',
		saveNotificationConfigConfirmed : ".save-notification-preference-cofirmed",
		inboundDiscrepanciesNotification : "#inboundDiscrepanciesNotification",	
  	};
  	const saveURL=el.data("save-notification-preference-url");
  	const detailPageUrl=el.data("notification-preference-detail-url");
  	let workOrderNotifcationConfig = el.data("workorder-notification-config");
	  let orderErrorNotifcationConfig = el.data("order-error-notification-config");
	  let inboundReceivingNotificationConfig = el.data("inbound-receiving-notification-config");
		let inboundCompleteNotifcationConfig = el.data("inbound-complete-notification-config");
		let inboundAgingNotificationConfig = el.data("inbound-aging-notification-config");
		let bulkOrderUploadFailsNotificationConfig = el.data("bulk-order-upload-fails-notification-config");
		let orderAddressValidationFailureNotificationConfig = el.data("order-address-validation-failure-notification-config");
		let transferOrderShippedNotificationConfig = el.data("transfer-order-shipped-notification-config");
		let transferOrderReceivedNotificationConfig = el.data("transfer-order-received-notification-config");
		let setWorkOrderToggleOn = el.data("workorder-notification-toggle-on-config");
		let inboundDiscrepanciesNotificationConfig = el.data("inbound-discrepancies-notification-config");
		

  	function setElements(){
    	setElementsFromScope(els, elementsMap, el);
 	}

 	onLoad();

 	function onLoad(){
 		setElements();
 		setElementValue();	
 		
 	}
 	
 	function setElementValue(){
		 els.orderErrorNotification.prop("checked", orderErrorNotifcationConfig);
		 els.inboundReceivingNotification.prop("checked", inboundReceivingNotificationConfig);
		 els.inboundStatusCompleteNotification.prop("checked", inboundCompleteNotifcationConfig);
		 els.inboundAgingNotification.prop("checked", inboundAgingNotificationConfig);
		 els.bulkOrderUploadFailsNotification.prop("checked", bulkOrderUploadFailsNotificationConfig);
		 els.addressValidationFailureNotification.prop("checked", orderAddressValidationFailureNotificationConfig);
		 els.transferOrderShippedNotification.prop("checked", transferOrderShippedNotificationConfig);
		 els.transferOrderReceivedNotification.prop("checked", transferOrderReceivedNotificationConfig);
		 els.inboundDiscrepanciesNotification.prop("checked", inboundDiscrepanciesNotificationConfig);
    if(setWorkOrderToggleOn){
      els.workOrderNotification.prop("checked", true);
      els.workOrderNotification.prop("disabled", true);
    }else{
      els.workOrderNotification.prop("checked", workOrderNotifcationConfig);
    }
 	}
 	

 	/*els.workOrderNotification.on("change", function(){
 		console.log("workOrderNotification value " + els.workOrderNotification.prop("checked"));
 	});


 	els.orderErrorNotification.on("change", function(){
 		console.log("orderErrorNotification value " + els.orderErrorNotification.is(":checked"));
 	});*/

	els.saveNotificationConfig.on("click", function(e){
		e.preventDefault();
		$("#save-confirmation-modal").appendTo("body").modal("show");
	});


	$(".save-notification-preference-cofirmed").on("click", function(e){
		save({url: saveURL,success: saveSuccess, error: saveError});
	});



  function save({url,success,error}) {
    submitModalFlow.showLoadingModal();
    $.ajax({
      data: new FormData($('#notification-preferences-config-form').get(0)),
      url: url,
      processData: false,
      contentType: false,
      dataType: "JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function saveSuccess(data){
    if(data.response == "success") {
      EditChecker.setPageClean();
      submitModalFlow.showSuccessModal();
      setTimeout(function() {
        location.href = `${detailPageUrl}`;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

    } else {
      submitModalFlow.showFailureModal();
    }
  }

  function saveError(){
	submitModalFlow.hideAllModals();
  }
}





// WEBPACK FOOTER //
// ./src/pages/notificationPreferences/notificationPreferences.js